var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.getters.isAuthenticated)?_c('header-after-login'):_vm._e(),(!this.$store.getters.isAuthenticated)?_c('header-before-login'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }